import { lazy } from 'react';

export const YourGenderPageLazy = lazy(() => import('./your-gender'));
